jQuery(document).ready(function($) {
    $('a[href^="#scroll-to-section-"]').on('click', function(e) {
        e.preventDefault();
        let target = $(this).attr('href').replace('#scroll-to-section-', '');
        let section = $('section').eq(target);
        $('html, body').animate({
            scrollTop: section.offset().top
        }, 1000);
    });
});